<template>
  <div id="sales">
    <Datatable class="datatable" entity="sale_status"/>
  </div>
</template>
<script>

  import Datatable from "@/components/Datatable.vue";

  export default {

    name: 'salesStatus',
    components: { Datatable },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "sales.title";
      this.$store.state.pageIcon = "/icon/sales.svg";
    }
  };

</script>

<style lang="scss" scoped>
  .datatable {
    height: 100%;
  }
</style>